<template>
    <div class="tc-cases-menu-container">
        <div class="tc-cases-menu-navigation tc-thin-scrollbar">
            <div class="tc-cases-menu-navigation-inner">
                <CaseMenuNavigationItem :label="'Готовые решения'"
                                        :is-active="storeUI.caseMenuCategory.includes('template')"
                                        @select="storeUI.setCaseMenuCategory([ 'template' ])">
                    <template #icon>
                        <SVGCaseTemplate/>
                    </template>
                </CaseMenuNavigationItem>
                <div class="tc-case-menu-navigation-separator"></div>
                <CaseMenuNavigationItem :label="'Экраны'"
                                        :is-active="storeUI.caseMenuCategory.includes('shield')"
                                        @select="storeUI.setCaseMenuCategory([ 'shield' ])">
                    <template #icon>
                        <SVGShield/>
                    </template>
                </CaseMenuNavigationItem>
                <CaseMenuNavigationItem :label="storeCaseConfiguration.selectedCaseModel ===
                                                                'HARD-1000' ? 'Полки и столешницы' : 'Полки'"
                                        :is-active="storeUI.caseMenuCategory
                                        .find(x => x === 'shelf' || x === 'shelfCNC' || x === 'shelfCNCHard')"
                                        @select="storeUI.setCaseMenuCategory([ 'shelf', 'shelfCNC', 'shelfCNCHard' ])">
                    <template #icon>
                        <SVGShelf/>
                    </template>
                </CaseMenuNavigationItem>
                <CaseMenuNavigationItem :label="'Ящики'"
                                        :is-active="storeUI.caseMenuCategory.includes('drawer')"
                                        @select="storeUI.setCaseMenuCategory([ 'drawer' ])">
                    <template #icon>
                        <SVGDrawer/>
                    </template>
                </CaseMenuNavigationItem>
                <CaseMenuNavigationItem :label="'Перегородки'"
                                        :is-active="storeUI.caseMenuCategory
                                        .find(x => x === 'separator' || x === 'separatorT')"
                                        @select="storeUI.setCaseMenuCategory([ 'separator', 'separatorT' ])">
                    <template #icon>
                        <SVGSeparator/>
                    </template>
                </CaseMenuNavigationItem>
                <CaseMenuNavigationItem :label="'Аксессуары'"
                                        :is-active="storeUI.caseMenuCategory.includes('accessory')"
                                        @select="storeUI.setCaseMenuCategory([ 'accessory' ])">
                    <template #icon>
                        <SVGAccessory/>
                    </template>
                </CaseMenuNavigationItem>
            </div>
        </div>
        <div class="tc-cases-menu-items-container tc-thin-scrollbar">
            <div class="tc-cases-menu-items-inner">
                <div class="tc-div-contents"
                     v-if="storeUI.caseMenuCategory.includes('template')">
                    <CaseMenuItemSelect v-for="item in casePresetOfSelectedType"
                                        :item="item"
                                        @select-preset="selectPreset(item)"/>
                </div>
                <div class="tc-div-contents" v-else>
                    <CaseMenuItemDND v-for="item in caseComponentsOfSelectedType"
                                     :item="item"/>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import CaseMenuNavigationItem from '@/UI/LeftSidebar/Components/CaseMenuNavigationItem.vue';
import CaseMenuItemDND from '@/UI/LeftSidebar/Components/CaseMenuItemDND.vue';
import CaseMenuItemSelect from '@/UI/LeftSidebar/Components/CaseMenuItemSelect.vue';
import SVGCaseTemplate from '@/UI/SVG/SVGCaseTemplate.vue';
import SVGShield from '@/UI/SVG/SVGShield.vue';
import SVGShelf from '@/UI/SVG/SVGShelf.vue';
import SVGDrawer from '@/UI/SVG/SVGDrawer.vue';
import SVGSeparator from '@/UI/SVG/SVGSeparator.vue';
import SVGAccessory from '@/UI/SVG/SVGAccessory.vue';
import { useStoreUI } from '@/Store/storeUI';
import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import { caseComponentsLib } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { presetsLib } from '@/Constants/presetsLib';
import { useStorePresets } from '@/Store/storePresets';

export default {
    name: 'LeftSidebarCase',
    components: {
        OutlineButton,
        SVGAccessory,
        SVGSeparator,
        SVGDrawer,
        SVGShelf,
        SVGShield,
        SVGCaseTemplate,
        CaseMenuItemSelect,
        CaseMenuItemDND,
        CaseMenuNavigationItem,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storePresets = useStorePresets();
        return {
            storeUI,
            storeCaseConfiguration,
            storePresets,
        };
    },
    data() {
        return {
            caseComponents: [ ...caseComponentsLib.filter(x => !x.noVisible) ],
            casePresets: [ ...presetsLib ],
        };
    },
    methods: {
        selectPreset(preset) {
            this.storeCaseConfiguration.$patch(JSON.parse(JSON.stringify(preset.json)));
        },
    },
    computed: {
        caseComponentsOfSelectedType() {
            return this.caseComponents
                .filter(item => this.storeUI.caseMenuCategory.includes(item.type) &&
                    item.caseModels.includes(this.storeCaseConfiguration.selectedCaseModel));
        },
        casePresetOfSelectedType() {
            return this.storePresets.getPresetsByCaseModel(this.storeCaseConfiguration.selectedCaseModel);
            // return presets.map(preset => JSON.parse(JSON.stringify(preset.json)));
            // return this.casePresets
            //     .filter(item => item.selectedCaseModel === this.storeCaseConfiguration.selectedCaseModel);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/scrollbar";

.tc-cases-menu-container {
    box-sizing: border-box;
    width: 100%;
    //height: calc(100% - 40px);
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
}

.tc-cases-menu-navigation {
    display: flex;
    width: 120px;
    height: 100%;
    overflow-y: auto;
    border-right: 1px solid #D9D9D9;
    box-sizing: border-box;

}

.tc-cases-menu-navigation-inner {
    display: flex;
    height: max-content;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    gap: 10px;
    align-items: center;
}

.tc-case-menu-navigation-separator {
    width: calc(100% - 30px);
    box-sizing: border-box;
    height: 1px;
    border-top: 1px solid #D9D9D9;
    display: flex;
}

.tc-cases-menu-items-container {
    display: flex;
    flex: 1;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}

.tc-cases-menu-items-inner {
    display: flex;
    height: max-content;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    gap: 15px;
    align-items: center;
}

</style>
